import React, { useEffect, useState } from 'react';
import LockClosedSVG from 'src/assets/svg/lock-closed.svg';
import {
  Base, Button, Select, toast
} from 'src/components';
import { updateCompanyQuery, useCompany } from 'src/queries/company';
import COMMON_CONSTANTS from 'common/commonConstants';
import STYLE from 'src/constants/style';

const { EMAIL_FREQUENCY } = COMMON_CONSTANTS;

const FREQUENCY_STEPS = [
  {
    label: 'Two times per week',
    value: EMAIL_FREQUENCY.BIWEEKLY.value
  },
  {
    label: 'Every week',
    value: EMAIL_FREQUENCY.WEEKLY.value
  },
  {
    label: 'Every 10 days',
    value: EMAIL_FREQUENCY.EVERY_10_DAYS.value
  },
  {
    label: 'Every 2 weeks (Recommended)',
    value: EMAIL_FREQUENCY.BIMONTHLY.value
  },
  {
    label: 'Every 3 weeks',
    value: EMAIL_FREQUENCY.EVERY_3_WEEKS.value
  },
  {
    label: EMAIL_FREQUENCY.MONTHLY.value,
    value: EMAIL_FREQUENCY.MONTHLY.value
  },
  {
    label: EMAIL_FREQUENCY.EVERY_6_WEEKS.label,
    value: EMAIL_FREQUENCY.EVERY_6_WEEKS.value
  },
  {
    label: EMAIL_FREQUENCY.EVERY_8_WEEKS.label,
    value: EMAIL_FREQUENCY.EVERY_8_WEEKS.value
  },
  {
    label: EMAIL_FREQUENCY.EVERY_QUARTER.label,
    value: EMAIL_FREQUENCY.EVERY_QUARTER.value
  }
];

const ReviewFrequency = () => {
  const {
    data: company,
    refetch: refetchCompany,
    isFetching: isFetchingCompany,
    isError: isErrorCompany
  } = useCompany();

  const isFetching = isFetchingCompany;
  const isError = isErrorCompany;
  const isReady = company && company.id && !isFetching && !isError;

  const { mutateAsync: updateCompany, isLoading: updateCompanyLoading } = updateCompanyQuery();
  const [frequency, setFrequency] = useState(FREQUENCY_STEPS[0]);

  useEffect(() => {
    if (isReady) {
      const defaultFreq = FREQUENCY_STEPS.find(
        (i) => i.value === company.emailFrequency
      );
      setFrequency(defaultFreq);
    }
  }, [isReady]);

  if (!isReady) {
    return null;
  }

  const save = async () => {
    toast.show('Updating review frequency..');
    await updateCompany({
      emailFrequency: frequency.value
    });
    toast.show('Saved!');
    refetchCompany();
  };

  const getDisabledTooltip = () => {
    if (!company.active) {
      return 'Company is not active';
    }
    if (company.demo) {
      return 'Disabled in demo mode';
    }
  };

  return (
    <Base
      classes={`${STYLE.CONTAINER_WHITE} items-start`}
      loading={isFetchingCompany || updateCompanyLoading}
    >
      <h5 className='mb-1 font-bold inline-block'>Review Cycle</h5>
      {company.demo ? (
        <span className='ml-2 mt-1 w-5 h-5 align-top inline-block tooltip'>
          <span className='tooltip-text bg-black text-white -mt-10 -ml-16'>
            {getDisabledTooltip()}
          </span>
          <LockClosedSVG />
        </span>
      ) : null}
      <p className='mb-4'>
        Determines how often reviews are sent for each review relationship as
        well as the frequency of summary updates.
      </p>

      <Select
        id='reviewFrequency'
        variant='shadow'
        classes='w-full mb-10'
        title={frequency.label}
        options={FREQUENCY_STEPS}
        onChange={(option) => setFrequency(option)}
        disabled={company.demo || !company.active}
      />

      <Button
        variant='black'
        classes='py-1 mt-2 mb-1 whitespace-nowrap h-[39.5px]'
        onClick={save}
        disabled={
          frequency.value === company.emailFrequency
          || updateCompanyLoading
          || isFetchingCompany
          || !company.active
          || company.demo
        }
      >
        Save
      </Button>
    </Base>
  );
};

export default ReviewFrequency;
